import { SerializedFile } from 'fym-common/src/db/serializersTypes';

export enum FieldsName {
  image = 'image',
}

export type FieldsType = {
  [FieldsName.image]: SerializedFile;
};
